import { ETH } from "../constants";
import { FarmInToken, FarmState } from "./types";

const WETH: FarmInToken = {
  address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
  symbol: "WETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const rsETH: FarmInToken = {
  address: "0x4186BFC76E2E237523CBC30FD220FE055156b41F",
  symbol: "rsETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const weETH: FarmInToken = {
  address: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
  symbol: "weETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const KNOX: FarmInToken = {
  address: "0x0BBF664D46becc28593368c97236FAa0fb397595",
  symbol: "KNOX",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};
const ETHPlus: FarmInToken = {
  address: "0x18C14C2D707b2212e17d1579789Fc06010cfca23",
  symbol: "ETH+",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

const PT_rsETH_26DEC2024: FarmInToken = {
  address: "0x355ec27c9d4530dE01A103FA27F884a2F3dA65ef",
  decimals: 18,
  symbol: "PT-rsETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
};

const Unieth: FarmInToken = {
  address: "0x3d15fD46CE9e551498328B1C83071D9509E2C3a0",
  decimals: 18,
  symbol: "uniETH",
  shouldBeSwapped: true,
  needApprove: true,
};

const PT_uniETH_26DEC2024: FarmInToken = {
  address: "0x22e9aD26eA0e65a7073571d5D7172ff6336084AD",
  decimals: 18,
  symbol: "PT-uniETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
};

const PT_weETH_26DEC2024: FarmInToken = {
  address: "0xE2B2D203577c7cb3D043E89cCf90b5E24d19b66f",
  decimals: 18,
  symbol: "PT-weETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
};

const USDC: FarmInToken = {
  address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
  symbol: "USDC",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 6,
};

const PT_USDe_28NOV2024: FarmInToken = {
  address: "0x1FA42e6730DF74fF2742704761Da41111bB7F019",
  decimals: 18,
  symbol: "PT-USDe-28NOV2024",
  shouldBeSwapped: false,
  needApprove: true,
};

const PT_gUSDC_6DEC2024: FarmInToken = {
  address: "0x2Be6Fab4d1408e7ad6AD91cE7B77FA2A7670782f",
  decimals: 18,
  symbol: "PT-gUSDC-6DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
};

const PT_rsETH_26JUN2025: FarmInToken = {
  address: "0x8Db96f2FcCf7Cdd74a60e8eFf5801df043cd11dE",
  decimals: 18,
  symbol: "PT-rsETH-26JUN2025",
  shouldBeSwapped: false,
  needApprove: true,
};

const PT_wstETH_26JUN2025: FarmInToken = {
  address: "0x1255638EFeca62e12E344E0b6B22ea853eC6e2c7",
  decimals: 18,
  symbol: "PT-wstETH-26JUN2025",
  shouldBeSwapped: false,
  needApprove: true,
};

const PT_uniETH_26JUN2025: FarmInToken = {
  address: "0xB3eBcC844F1Eda040a3620267CDaAea6E14518A9",
  decimals: 18,
  symbol: "PT-uniETH-26JUN2025",
  shouldBeSwapped: false,
  needApprove: true,
};

const PT_weETH_26JUN2025: FarmInToken = {
  address: "0xb33808ea0e883138680BA29311a220A7377cdb92",
  decimals: 18,
  symbol: "PT-weETH-26JUN2025",
  shouldBeSwapped: false,
  needApprove: true,
};

const PT_rETH_26JUN2025: FarmInToken = {
  address: "0x1255638EFeca62e12E344E0b6B22ea853eC6e2c7",
  decimals: 18,
  symbol: "PT-rETH-26JUN2025",
  shouldBeSwapped: false,
  needApprove: true,
};

export const ARBITRUM_FARM_STATE: FarmState = {
  "0x3125e87D2630eb7DADD7F94e2fE05Bd21eE10C4f": {
    tokens: [KNOX],
  },
  "0xb1Af7B299ABBE4905Bbc80E614f64caCFEfBc96b": {
    tokens: [ETHPlus],
  },
  "0x5ecE952A12b87f909b4Bd8137DD30fd07b80c2C4": {
    tokens: [ETH, WETH, PT_rsETH_26DEC2024, rsETH],
    priceImpactToken: WETH,
  },
  "0x1be9c0343F6A5E3F1E8c76e6cEF05EEbda4074D3": {
    tokens: [ETH, WETH, PT_uniETH_26DEC2024, Unieth],
    priceImpactToken: WETH,
  },
  "0x2E70CC46F465ab249D6972cCeb0363a6B07AeA01": {
    tokens: [ETH, WETH, PT_weETH_26DEC2024, weETH],
    priceImpactToken: WETH,
  },
  "0x760B9fE6b1f6c5dD7597A02690ffe3F6a07a3042": {
    tokens: [USDC, PT_USDe_28NOV2024],
    priceImpactToken: USDC,
  },
  "0x230A545aBE3217BA3BdA3EEec2D8582dFD4B73CE": {
    tokens: [USDC, PT_gUSDC_6DEC2024],
    priceImpactToken: USDC,
  },
  "0x9007A45304Ac6676CEf22ec68c870ae88Af60065": {
    tokens: [USDC],
    priceImpactToken: USDC,
  },
  "0x856e0317130F468d2bcd104b42B82337300765b0": {
    tokens: [ETH, WETH, PT_wstETH_26JUN2025],
    priceImpactToken: WETH,
  },
  "0xC8C1CdD42D02eaF4F775eaF9f4b4a37a5272118d": {
    tokens: [ETH, WETH, PT_rETH_26JUN2025],
    priceImpactToken: WETH,
  },
  "0xe302CA50234D336A8Cff0AD11Af1Aa00C0F174e2": {
    tokens: [ETH, WETH, PT_weETH_26JUN2025],
    priceImpactToken: WETH,
  },
  "0x727B79bFd88600fa425619280bc24A0B60Cf14DA": {
    tokens: [ETH, WETH, PT_rsETH_26JUN2025],
    priceImpactToken: WETH,
  },
  "0x8A048FdC480ADEc0C7A77277F398709AEa7e4461": {
    tokens: [ETH, WETH, PT_uniETH_26JUN2025],
    priceImpactToken: WETH,
  },
};
